import { UploadedFile } from 'shared_DEPRECATED/components/File';
import { UploadedFileImage } from 'shared_DEPRECATED/components/File/UploadedFileImage';
import { isImage } from 'shared_DEPRECATED/components/File/utils';
import { Attachment } from 'shared_DEPRECATED/types/Attachment';

import { UnuploadedAttachment } from 'features/chat/config/types/Attachment';

type ChatAttachmentUploadedProps = {
  file: UnuploadedAttachment | Attachment;
  children: React.ReactNode;
};

export const ChatAttachmentUploaded = ({
  file,
  children,
}: ChatAttachmentUploadedProps) =>
  isImage(file.contentType) ? (
    <UploadedFileImage
      name={file.name}
      contentType={file.contentType}
      src={'file' in file ? URL.createObjectURL(file.file) : file.url}
    >
      {children}
    </UploadedFileImage>
  ) : (
    <UploadedFile name={file.name} contentType={file.contentType}>
      {children}
    </UploadedFile>
  );
